import { Box, Column, ConfirmPopup, FieldValue, Label, Text } from '~/commonComponents';
import InputSelect from '~/commonComponents/InputSelect';
import { Colors } from '~/themes/colors';
import { useRequestReport } from './hooks';
import { Controller } from 'react-hook-form';
import { useEffect } from 'react';

interface IProps {
  onClose: () => void;
}

export const RequestReportPopup = ({ onClose }: IProps) => {
  const {
    controller: {
      control,
      formState: { isValid },
    },
    isError,
    isLoading,
    isSuccess,
    onSubmit,
  } = useRequestReport();

  useEffect(() => {
    if (!isLoading && (isSuccess || isError)) {
      onClose();
    }
  }, [isError, isLoading, isSuccess, onClose]);

  return (
    // @ts-expect-error -- ConfirmPopup still written in JavaScript
    <ConfirmPopup
      leftButtonAction={onClose}
      leftButtonDisabled={isLoading}
      leftButtonStyle={{ width: 180 }}
      leftButtonText="Close"
      rightButtonAction={onSubmit}
      rightButtonDisabled={!isValid}
      rightButtonLoading={isLoading}
      rightButtonStyle={{ width: 180 }}
      rightButtonText="Submit Request"
      title="Request Report"
      modalStyle={{ width: 560 }}
    >
      <Text textAlign="center" color={Colors.neutral_500}>
        Please complete the form below to request a transactions
        <br />
        report from GoTu. Once submitted, an email will be sent to
        <br />
        the address specified below.
      </Text>
      <Column marginTop={24} width={386} paddingBottom={24} gap={16}>
        <Controller
          control={control}
          name="email"
          rules={{ required: true, pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ }}
          render={({ field }) => (
            <FieldValue
              customInputStyle={{ width: '100%', boxSizing: 'border-box' }}
              label="Forwarding Email"
              placeholder="Enter Forwarding Email"
              required
              shouldCapitalize={false}
              value={field.value}
              setValue={field.onChange}
            />
          )}
        />
        <Box>
          <Label text="Transaction Date Range" required />
          <Controller
            control={control}
            name="ranges"
            rules={{ required: true }}
            render={({ field }) => (
              // @ts-expect-error -- InputSelect still written in JavaScript
              <InputSelect
                isSelectVisible={false}
                options={
                  [
                    { title: 'All', value: 'All' },
                    { title: 'Current Month', value: 'Current Month' },
                    { title: 'Last Month', value: 'Last Month' },
                    { title: 'Previous 3 months', value: 'Previous 3 months' },
                    { title: 'Previous 6 months', value: 'Previous 6 months' },
                    { title: 'Year to Date', value: 'Year to Date' },
                    { title: 'Last Year', value: 'Last Year' },
                  ] as any
                }
                setValue={field.onChange}
                value={field.value}
              />
            )}
          />
        </Box>
        <Box>
          <Label text="Notes" marginBottom={8} required={false} />
          <Controller
            control={control}
            name="notes"
            render={({ field }) => (
              <textarea
                {...field}
                className="textarea-style"
                style={{
                  width: '-webkit-fill-available',
                  height: 70,
                }}
              />
            )}
          />
        </Box>
      </Column>
    </ConfirmPopup>
  );
};
